import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { PdpSharedBlurbRareFind_item$key } from './__generated__/PdpSharedBlurbRareFind_item.graphql';

// components
import Sparkle from 'dibs-icons/exports/Sparkle';
import { PdpSharedBlurb } from './PdpSharedBlurb/PdpSharedBlurb';
import { PdpSharedRecentSalesCopy } from '../PdpSharedRecentSales/PdpSharedRecentSalesCopy';

// helpers
import { rareFindTitle } from '../messages/pdpBlurbMessages';
import { useIsRareFind } from '../PdpSharedRecentSales/useIsRareFind';

type Props = {
    item: PdpSharedBlurbRareFind_item$key;
};

export const PdpSharedBlurbRareFind: FC<Props> = ({ item: itemRef }) => {
    const item = useFragment(
        graphql`
            fragment PdpSharedBlurbRareFind_item on Item {
                ...PdpSharedRecentSalesCopy_item
                ...useIsRareFind_item
            }
        `,
        itemRef
    );

    const isRareFind = useIsRareFind(item);

    if (!isRareFind) {
        return null;
    }

    return (
        <PdpSharedBlurb
            IconComponent={Sparkle}
            title={rareFindTitle}
            detail={<PdpSharedRecentSalesCopy item={item} />}
        />
    );
};

export default PdpSharedBlurbRareFind;
